import type { ReactNode } from 'react';
import { MockPill } from '@components/ui/MockPill/MockPill';
import styles from './CardHeader.module.css';

interface ICardHeaderProps {
  icon?: ReactNode;
  title: ReactNode;
  meta?: ReactNode;
  size?: 'sm' | 'md';
  mock?: boolean;
}

/**
 * Shared card header for the Productivity surface — accent icon + title
 * on the left, uppercase meta on the right.
 */
export function CardHeader({ icon, title, meta, size = 'md', mock = false }: ICardHeaderProps) {
  return (
    <header className={styles.header}>
      <h2 className={styles.title} data-size={size}>
        {icon}
        {title}
        {mock && <MockPill kind="badge" />}
      </h2>
      {meta != null && <span className={styles.meta}>{meta}</span>}
    </header>
  );
}
